<ion-card mode="ios" class="deal-card" [style.height]="cardHeight">
  <ion-badge  *ngIf="outlet.yum_points" 
  (click)="explainPoints()"
    color="primary"
    mode="ios">
     
    <ion-icon name="ribbon" size="large"></ion-icon>
  </ion-badge>
    <ion-grid  fixed id="main-grid">
      <ion-row (click)="cardClick()" id="main-row">
        <ion-col id="main-col">
          <div id="img-container" class="fade-in">
            <img  
            [style.height]="cardHeight"
            id="background-image"
            [defaultImage]="assetLinksService.cardLoading" 
            [lazyLoad]="outlet.image" 
            [errorImage]="assetLinksService.noImage"
            onerror="this.src='assets/errorimg_ink.png'">
          </div>
        </ion-col>
      </ion-row>
      <div id="text-container">
        <ion-row class="fade-in" (click)="cardClick()">
          <ion-col>
          <p id="reward"> {{outlet.name}}</p>
          </ion-col>
        </ion-row>
      </div>
    </ion-grid>
</ion-card>

